import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Skeleton } from "@/components/ui/skeleton";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const STATUS = ["New", "Contacted", "Waiting for Customer", "Fitment Under Review", "Quote Sent", "Converted", "Closed", "Spam"];
const KINDS = [
  { key: "contact", label: "Contact", collection: "contact_inquiries", idField: "inquiry_id" },
  { key: "fitment", label: "Fitment", collection: "fitment_requests", idField: "request_id" },
  { key: "parts", label: "Part Requests", collection: "part_requests", idField: "request_id" },
  { key: "wholesale", label: "Wholesale", collection: "wholesale_applications", idField: "application_id" },
];

function InquiryList({ items = [], collection, idField, refresh }) {
  const setStatus = async (id, status) => {
    await api.post(`/admin/inquiries/${collection}/${id}/status`, { status });
    refresh();
  };
  if (!items.length) return <div className="text-sm text-slate-500 p-6">Nothing here yet.</div>;
  return (
    <div className="space-y-2">
      {items.map((i) => (
        <div key={i[idField]} className="rounded-lg border border-white/10 bg-white/5 p-4">
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="text-white font-heading font-semibold">{i.business_name || i.name || i.email}</div>
              <div className="text-xs text-slate-400 mt-0.5">{i.email} {i.phone && <>· {i.phone}</>}</div>
              <div className="text-xs font-mono text-slate-500 mt-1">{new Date(i.created_at).toLocaleString()}</div>
              {(i.message || i.notes || i.product_needed) && (
                <div className="text-sm text-slate-300 mt-2 max-w-2xl">{i.message || i.notes || `Product needed: ${i.product_needed}`}</div>
              )}
              {(i.year || i.make || i.model) && (
                <div className="text-xs font-mono text-slate-500 mt-1">{i.year} {i.make} {i.model} {i.engine ? `· ${i.engine}` : ""}</div>
              )}
            </div>
            <Select value={i.status || "New"} onValueChange={(v) => setStatus(i[idField], v)}>
              <SelectTrigger className="w-44 bg-white/5 border-white/10 text-white">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>{STATUS.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        </div>
      ))}
    </div>
  );
}

export default function OwnerInquiries() {
  const [data, setData] = useState(null);
  const refresh = () => api.get("/admin/inquiries").then(({ data }) => setData(data));
  useEffect(() => { refresh(); }, []);
  if (!data) return <Skeleton className="h-96 bg-white/5" />;
  return (
    <div data-testid="owner-inquiries">
      <h1 className="font-display text-3xl font-extrabold text-white">Inquiries</h1>
      <Tabs defaultValue="contact" className="mt-6">
        <TabsList className="bg-white/5 border border-white/10">
          {KINDS.map((k) => <TabsTrigger key={k.key} value={k.key}>{k.label} <span className="ml-1 text-xs font-mono text-slate-400">({(data[k.key] || []).length})</span></TabsTrigger>)}
        </TabsList>
        {KINDS.map((k) => (
          <TabsContent key={k.key} value={k.key} className="mt-4">
            <InquiryList items={data[k.key]} collection={k.collection} idField={k.idField} refresh={refresh} />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
